import React, { useContext } from "react";
import AuthContext from "../../../store/auth-context";
import cookies from 'js-cookie';
const NavBar = ()=>{
  const authCtx = useContext(AuthContext)
  const displayName = authCtx.displayname
  const handleToggleSideBar = ()=>{
   document.querySelector("body")?.classList.toggle("toggle-sidebar")
  }



  const handleSignOut = ()=>{
   authCtx.Logout()
  }
    return (
        <div>
           
  
  <header id="header" className="header fixed-top d-flex align-items-center">

    <div className="d-flex align-items-center justify-content-between">
      <a href="" className="logo d-flex align-items-center">
        <img src="assets/img/logo.png" alt=""/>
        <span className="d-none d-lg-block">My Dashboard</span>
      </a>
      <i className="bi bi-list toggle-sidebar-btn" onClick={handleToggleSideBar}></i>
    </div>

   

    <nav className="header-nav ms-auto">
      <ul className="d-flex align-items-center">

     
   

       

        <li className="nav-item dropdown pe-3">

          <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
           
            <i className="bi bi-person"></i>
            <span className="d-none d-md-block dropdown-toggle ps-2">{displayName}</span>
          </a>

          <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
            <li className="dropdown-header">
              <h6>{displayName}</h6>
              
            </li>
            <li>
              <hr className="dropdown-divider"/>
            </li>

          
          
          
           
            <li>
              <hr className="dropdown-divider"/>
            </li>

            <li>
              <button className="dropdown-item d-flex align-items-center" onClick={()=>{handleSignOut()}}>
                <i className="bi bi-box-arrow-right"></i>
                <span>Sign Out</span>
              </button>
            </li>

          </ul>
        </li>

      </ul>
    </nav>

  </header>
        </div>
    )
}


export default NavBar